/**
 * @file 支払情報を管理するステート
 *
 * 支払情報APIから取得した現在の支払方法（クレジットカード・口座振替・コンビニ等）と、
 * 支払方法変更画面で選択された新しい支払方法をそれぞれ別のatomで保持する。
 * paymentInfoState: APIレスポンスの現在の支払情報。
 * paymentMethodState: 支払方法変更画面で選択された新しい支払方法。
 * セッションストレージに永続化される。
 */
import { atom } from 'recoil';
import { PaymentInfoResponse } from '@/types/api/mypage/paymentInfo';
import persistAtom from './recoilPersist';

/** 現在の支払情報を保持するRecoil atom */
export const paymentInfoState = atom<PaymentInfoResponse>({
  key: 'paymentInfoState',
  default: {
    bl_id: '',
    payment_type: '',
  },
  effects_UNSTABLE: [persistAtom],
});

/** 支払方法変更画面で選択された新しい支払方法の型 */
export type PaymentMethodType = {
  /** 支払方法タイプ（Constants.PaymentMethodのコード値） */
  paymentType: string;
};

/** 支払方法変更画面で選択された新しい支払方法を保持するRecoil atom */
export const paymentMethodState = atom<PaymentMethodType>({
  key: 'paymentMethodState',
  default: {
    paymentType: '',
  },
  effects_UNSTABLE: [persistAtom],
});

export default paymentMethodState;
